import { Component, ViewChild, OnInit, OnDestroy, HostBinding, HostListener, Renderer2 } from '@angular/core';
import {OverlayContainer} from '@angular/cdk/overlay';
import { MatSidenav } from '@angular/material/sidenav';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { LanguageService, AppLanguage } from '../../services/language.service';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'src/app/services/api.service';
import { Role } from 'src/app/model/role';
import { SessionService } from '../../services/session.service';
import { AnnouncementService } from '../../services/announcement.service';
import { AnnouncementPopupComponent } from '../../dialogs/announcement-popup/announcement-popup.component';
import { AnnouncementComposeComponent } from '../../dialogs/announcement-compose/announcement-compose.component';

@Component({
  selector: 'app-mainlayout',
  templateUrl: './mainlayout.component.html',
  styleUrls: ['./mainlayout.component.scss'],
})
export class MainlayoutComponent implements OnInit, OnDestroy {

  isSysAdmin : boolean = false;
  isCustomerCare: boolean = false;
  isCustomerService : boolean =false;
  isExpenseRoleVisible : boolean = false;
  isEmployeesVisible : boolean = false;
  isSysAdminOrFinance : boolean = false;
  isSuperAdmin : boolean = false;
  isAdmin : boolean = false;
  isHr : boolean = false;
  isPayments : boolean = false;

  loggedInUserId: string | null = null;
  loggedInUserName: string | null = null;

  // Branch support
  isSuperSysAdmin: boolean = false;
  userBranch: string = '';
  branches: string[] = [];
  selectedBranch: string = 'ALL';

  constructor(private cookieService: CookieService, private router: Router,private apiService: ApiService,private renderer: Renderer2,
    private overlayContainer: OverlayContainer, private languageService: LanguageService,
    private dialog: MatDialog, private announcementService: AnnouncementService, private snackBar: MatSnackBar,
    private sessionService: SessionService){
    // Dark theme is the default; only an explicit 'light' choice overrides it.
    this.darkModeUI = localStorage.getItem('theme') !== 'light';
    this.renderPageBodyColor();
    this.applyThemeToOverlayContainers();
  }

  
  ngOnInit(): void {
   // this.isSysAdmin = sessionStorage.getItem("issysadmin") === "true";
    this.checkLoginType();
    this.startAnnouncementPolling();
    this.startSessionWatchdog();
    this.startHeartbeat();
  }

  ngOnDestroy(): void {
    if (this.announcementTimer) { clearInterval(this.announcementTimer); this.announcementTimer = null; }
    if (this.sessionTimer) { clearInterval(this.sessionTimer); this.sessionTimer = null; }
    if (this.heartbeatTimer) { clearInterval(this.heartbeatTimer); this.heartbeatTimer = null; }
  }
  @ViewChild('sidenav') sidenav: MatSidenav;
  isExpanded = true;
  public darkModeUI = false;
  showSubmenu: boolean = false;
  isShowing = false;
  showSubSubMenu: boolean = false;
  emprole:String;
  checkLoginType() {
    const loggedInUser = window.localStorage.getItem('loggedInUser');
    this.loggedInUserId = loggedInUser;
    if (!loggedInUser) {
      this.clearSessionAndGoToLogin();
      return;
    }
    this.apiService.getEmplyeeDetailsById(loggedInUser).subscribe((data : any) => {
      
       this.loggedInUserName = data.employeeName || null;
       if (this.loggedInUserName) {
         localStorage.setItem('loggedInUserName', this.loggedInUserName);
       }

       // Branch scope: persist so the interceptor + other pages can use it
       this.userBranch = data.branchName || '';
       localStorage.setItem('userBranch', this.userBranch);

       let roles = data.roles.map((role : Role)=>role.roleName);
       if (roles.includes('supersysadmin')) {
         this.isSuperSysAdmin = true;
         localStorage.setItem('isSuperSysAdmin', 'true');
         this.selectedBranch = localStorage.getItem('selectedBranch') || 'ALL';
         this.loadBranches();
         this.isSysAdmin = true; // supersysadmin implies sysadmin menus
         this.isSuperAdmin = true;
       } else {
         localStorage.setItem('isSuperSysAdmin', 'false');
         localStorage.removeItem('selectedBranch');
       }
       if(roles.includes("sysadmin")){
        this.isSysAdmin = true;     
       }
        if(roles.includes("superadmin")){
        this.isSuperAdmin = true;     
       } 

         if(roles.includes("admin")){
        this.isAdmin = true;     
       } 
       if(roles.includes("hr")){
        this.isHr = true;
       }
       if(roles.includes("customercare") ){
        this.isCustomerCare = true; 
       }
        if(roles.includes("customerservice")){
         this.isCustomerService = true;
       }

        if(roles.includes("sysadmin") || roles.includes("finance") || (data.employeeDepartment =='collector' && (roles.includes("admin") || roles.includes("superadmin")))){
          this.isEmployeesVisible = true;
        }

        if(roles.includes("requester") || roles.includes("auditor") || roles.includes("approver")){
          this.isExpenseRoleVisible = true;
       }


          if(roles.includes("sysadmin") || roles.includes("finance")){
          this.isSysAdminOrFinance = true;
        }

       if(roles.includes("payments")){
          this.isPayments = true;
       }

       

       
    });
  }
  mouseenter() {
    if (!this.isExpanded) {
      this.isShowing = true;
    }
  }

  mouseleave() {
    if (!this.isExpanded) {
      this.isShowing = false;
    }
  }
  logout(){
    this.clearSessionAndGoToLogin();
  }

  private clearSessionAndGoToLogin(): void {
    this.cookieService.delete('LOGIN_TOKEN');
    window.localStorage.removeItem('loggedInUser');
    window.localStorage.removeItem('loggedInUserName');
    window.localStorage.removeItem('clientSessionId');
    window.localStorage.removeItem('userBranch');
    window.localStorage.removeItem('isSuperSysAdmin');
    window.localStorage.removeItem('selectedBranch');
    this.router.navigate(['login']);
  }

  loadBranches(): void {
    this.apiService.getBranches().subscribe({
      next: (res: any) => { this.branches = res?.branches || []; },
      error: () => { this.branches = []; }
    });
  }

  onBranchChange(branch: string): void {
    this.selectedBranch = branch || 'ALL';
    localStorage.setItem('selectedBranch', this.selectedBranch);
    // Reload so every screen re-fetches its data under the new branch scope
    window.location.reload();
  }

  // ---------- Session expiry (idle timeout) ----------
  // User is logged out after this much inactivity. Any click/key/touch/mouse
  // movement resets the clock (sliding expiration).
  private readonly IDLE_TIMEOUT_MS = 8 * 60 * 60 * 1000; // 8 hours
  private lastActivity = Date.now();
  private lastCookieRefresh = 0;
  private sessionTimer: any = null;

  private startSessionWatchdog(): void {
    this.lastActivity = Date.now();
    this.sessionTimer = setInterval(() => this.checkIdle(), 30000);
  }

  private checkIdle(): void {
    if (Date.now() - this.lastActivity > this.IDLE_TIMEOUT_MS) {
      this.snackBar.open('Session expired. Please log in again.', 'Close', { duration: 5000 });
      this.clearSessionAndGoToLogin();
    }
  }

  private onUserActivity(): void {
    this.lastActivity = Date.now();
    // Sliding renewal of the login cookie — at most once a minute so we
    // don't rewrite it on every mousemove.
    if (this.lastActivity - this.lastCookieRefresh > 60000) {
      this.lastCookieRefresh = this.lastActivity;
      this.cookieService.set('LOGIN_TOKEN', 'loggedIn');
    }
  }

  @HostListener('document:click')
  @HostListener('document:keydown')
  @HostListener('document:touchstart')
  @HostListener('document:mousemove')
  handleActivity(): void {
    this.onUserActivity();
  }

  // ---------- Session heartbeat (remote kick support) ----------
  private heartbeatTimer: any = null;

  private getClientSessionId(): string {
    let id = window.localStorage.getItem('clientSessionId');
    if (!id) {
      const c: any = crypto;
      id = c.randomUUID ? c.randomUUID() : `${Date.now()}-${Math.random()}`;
      window.localStorage.setItem('clientSessionId', id);
    }
    return id;
  }

  private startHeartbeat(): void {
    const beat = () => {
      const employeeId = window.localStorage.getItem('loggedInUser');
      if (!employeeId) { return; }
      this.sessionService.heartbeat(
        employeeId,
        window.localStorage.getItem('loggedInUserName'),
        this.getClientSessionId()
      ).subscribe({
        next: (res) => {
          if (res?.kicked) {
            this.snackBar.open('Your session was ended by an administrator.', 'Close', { duration: 5000 });
            this.clearSessionAndGoToLogin();
          }
        },
        error: () => { /* backend unreachable — keep working, idle timeout still applies */ }
      });
    };
    beat();
    this.heartbeatTimer = setInterval(beat, 30000);
  }

  // ---------- Announcements ----------
  private announcementTimer: any = null;
  private announcementOpen = false;

  /** Check immediately, then poll so logged-in users get new announcements too. */
  private startAnnouncementPolling(): void {
    this.checkAnnouncements();
    this.announcementTimer = setInterval(() => this.checkAnnouncements(), 30000);
  }

  private checkAnnouncements(): void {
    const employeeId = this.loggedInUserId || window.localStorage.getItem('loggedInUser');
    if (!employeeId || this.announcementOpen) { return; }
    this.announcementService.getPending(employeeId, 'web').subscribe({
      next: (list) => {
        if (list && list.length > 0 && !this.announcementOpen) {
          this.announcementOpen = true;
          const ref = this.dialog.open(AnnouncementPopupComponent, {
            width: '720px',
            maxWidth: '94vw',
            disableClose: true,
            data: { announcements: list, employeeId }
          });
          ref.afterClosed().subscribe(() => { this.announcementOpen = false; });
        }
      },
      error: () => { /* silent - announcements are non-critical */ }
    });
  }

  openAnnouncementCompose(): void {
    this.dialog.open(AnnouncementComposeComponent, {
      width: '520px',
      maxWidth: '92vw'
    });
  }

  setLang(lang: string) {
    const value = lang === 'so' ? 'so' : 'en';
    this.languageService.setLanguage(value as AppLanguage);
  }
  @HostBinding('class')
  public get themeMode() {
    return this.darkModeUI ? 'dark-theme' : 'light-theme';
  }

  /**
   * Listen for changes of the toggle state in child component "header"
   * Change the value of darkModeUI accordingly
   * Call page body background color rendering
   * @param $event The boolean emitted by the child component
   */
  public getDarkThemeOn($event) {
    this.darkModeUI = $event;
    localStorage.setItem('theme', this.darkModeUI ? 'dark' : 'light');
    this.renderPageBodyColor();
    this.applyThemeToOverlayContainers();
  }

  /**
   * Change the page body background color to match the content background
   * The name of the class is a reference to a CSS class in the styles.scss file
   * For example, 'dark' activates the 'body.dark' CSS class
   * Current theme classes must be explicitly removed before assigning another one
   * @private
   */
  private renderPageBodyColor() {
    this.renderer.removeClass(document.body, 'dark');
    this.renderer.removeClass(document.body, 'light');
    this.renderer.addClass(document.body, this.darkModeUI ? 'dark' : 'light');
  }

  /**
   * Propagate dynamic theme change to overly containers (dialogs eg)
   * The name of the class is a reference to a CSS class in the styles.scss file
   * For example, 'dark' activates the 'body.dark' CSS class
   * Current theme classes must be explicitly removed before assigning another one
   * @private
   */
  private applyThemeToOverlayContainers() {
    const overlayContainerClasses = this.overlayContainer.getContainerElement().classList;
    const classesToRemove = Array.from(overlayContainerClasses).filter(item => item.includes('-theme'));
    overlayContainerClasses.remove(...classesToRemove);
    this.overlayContainer.getContainerElement().classList.add(this.darkModeUI ? 'dark-theme' : 'light-theme');
  }
}
